import {useEffect, useState} from 'react';

import getCookie from '../utils/getCookie';
import {sdk} from '../utils/sdk';

const {user} = window.YC;

interface UserInfo {
    yandexuid?: string;
    login?: string;
}

const getCookies = (): UserInfo => {
    return {
        yandexuid: getCookie('yandexuid'),
        login: getCookie('yandex_login'),
    };
};

const isYandexUidChanged = (currentYandexUid?: string, savedYandexUid?: string) => {
    return currentYandexUid && currentYandexUid !== savedYandexUid;
};

const isLoginChanged = (currentLogin?: string, savedLogin?: string) => {
    return currentLogin && currentLogin?.toUpperCase() !== savedLogin?.toUpperCase();
};

const updateCSRF = () =>
    sdk.form
        .updateCSRF()
        .then((res) => {
            sdk.setCSRFToken(res);
            return true;
        })
        .catch(() => {
            return false;
        });

const maxTime = 1000;
const timeMultiplier = 2;

const useCSRFSync = () => {
    const [synced, setSynced] = useState(false);

    useEffect(() => {
        let saved = getCookies();
        let current: UserInfo = {...saved};
        let time = 5;

        function setTimer() {
            const newTime = time * timeMultiplier;
            time = newTime > maxTime ? maxTime : newTime;
            setTimeout(checkChanges, time);
        }

        const updateValues = (success: boolean) => {
            if (success) {
                saved = {...current};
                setTimer();
            }
        };

        function checkChanges() {
            current = getCookies();

            if (
                isYandexUidChanged(current.yandexuid, saved.yandexuid) ||
                isLoginChanged(current.login, saved.login)
            ) {
                updateCSRF().then(updateValues);
            } else {
                setTimer();
            }
        }

        if (isYandexUidChanged(saved.yandexuid, user?.yandexuid)) {
            updateCSRF()
                .then(updateValues)
                .finally(() => {
                    setSynced(true);
                });
        } else {
            setSynced(true);
            setTimer();
        }
    }, []);

    return synced;
};

export default useCSRFSync;
